module.exports = __webpack_public_path__ + "img/Step3.24c50027.jpg";